<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Technicians" title="Technician Profile" />
         
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            
                            <div class="row mb-3">
                                <div class="col-12">
                                    <router-link to="/technicians" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                                    <!-- <a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
                                </div>
                            </div>

                            <div class="row">

                                <div class=" col-lg-6 col-md-6">
                                    <div class="card overflow-hidden">
                                        <div class="bg-soft bg-primary">
                                            <div class="row m-0">
                                            <div class="col-7">

                                            </div>
                                            <div class="col-5 align-self-end">
                                                <img src="@/assets/images/details-img.png" alt="" class="img-fluid" width="150" height="150" />
                                            </div>
                                            </div>
                                        </div>
                                        <div class="card-body pt-2">
                                            <div class="row">
                                                <div class="col-sm-4"> 
                                                    <div class="avatar-md profile-user-wid mb-1">
                                                        <img src="@/assets/images/users/no-user.jpg" alt="" class="img-thumbnail rounded-circle" />
                                                    </div>
                                                </div>

                                                <div class="col-sm-8 align-self-center">
                                                    <h5 class="font-size-15">
                                                        {{ technician.name }}
                                                    </h5>
                                                    <p class="font-size-14 mt-3 mb-1">
                                                        <i class="fa fa-phone me-1 text-primary"></i>
                                                        {{ technician.country_code + " " + technician.mobile }}
                                                    </p>
                                                    <p class="font-size-14 mb-1">
                                                        <i class="fa fa-envelope me-1 text-primary"></i>
                                                        {{ technician.email || technician.user_name }}
                                                    </p>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <!-- end card -->
                                    <div class="d-grid gap-2">
                                        <!-- <b-button v-b-modal.password-modal block variant="primary">Change Password</b-button> -->
                                    </div>
                                

                                </div>
                            

                                <div class="col-lg-6 col-md-6">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Technician Details
                                        </h4>

                                        <div class="table table-responsive">
                                            <table class="details-table table-nowrap mb-0">
                                                <tbody>

                                                    <tr width="50%">
                                                        <th scope="row">Total Works</th>
                                                        <th>:</th>
                                                        <td>{{ job_stats.total_jobs }}</td>
                                                    </tr>

                                                    <tr width="50%">
                                                        <th scope="row">Total Works Completed</th>
                                                        <th>:</th>
                                                        <td>{{ job_stats.completed_jobs }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Total Incentives Earned</th>
                                                        <th>:</th>
                                                        <td>Rs.{{ technician.incentive }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Total Pending Works</th>
                                                        <th>:</th>
                                                        <td>{{ job_stats.pending_jobs }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Total Ongoing Works</th>
                                                        <th>:</th>
                                                        <td>{{ job_stats.ongoing_jobs }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Joined Date</th>
                                                        <th>:</th>
                                                        <td>{{ proxy.$filters.convertDate(technician.created_at) }}</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div> 
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>	
</template>

<script setup>
import { get } from '@/utils/api';
import { routes } from '@/constants/routes';
import { onMounted, ref, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Swal from '@/utils/swal';
import { goBack } from '@/utils/urlHider';

const { proxy } = getCurrentInstance();
const router = useRouter();
const route = useRoute();
const technician_id = route.query.id;


const technician = ref({});
const job_stats = ref({});
const fetchTecnition = () => {
    
    const params = {
        technician_id: technician_id
    }

        get(routes.TechnincianDetails, { params }, false)
        .then((response) => {
            if (response.status === 200) {
                console.log(response.data.data);
                technician.value = response.data.data.technician || response.data.data;
                job_stats.value = response.data.data.job_stats || {};
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
        })
        .catch((error) => {
            if (error.response?.status === 422) {
                Swal.fire('', error.response.data.message.technician_id?.[0] || 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
                Swal.fire('', error.response.data?.message || 'Error occured', 'error');
            }
        });
};

onMounted(() => {
    fetchTecnition();
});

const handleGoBack = () => {
	const success = goBack(router);
	if (!success) {
		// If no history, go to dashboard as fallback
		router.push({ name: 'defaultRoot' });
	}
};


</script>